import { getPreviousField } from './getPreviousField'

export const isPreviousFieldHasFilled = (
  configurationString: string,
  currentField: string
) => {
  if (!configurationString) return false

  const fields = configurationString?.split?.(';')
  const fieldsMapped = fields.map((item) => item.substring(0, 3))
  const previousField = getPreviousField(fieldsMapped, currentField)

  const prev = fields?.find((item) => item.substring(0, 3) === previousField)

  return (prev?.length || 0) > 3
}
